import CampCardServices from './camp_card_services.js';
import CampCardTags from './camp_card_tags.js';

import i18next from 'i18next';
import $ from 'jquery';

import { getTariffData } from '../new_design/common/map/tariff_utils';

export default class MapCampCard extends React.Component {
  constructor(props) {
    super(props);
    this.specialIcons = this.specialIcons.bind(this);
    this.handleFavoriteClick = this.handleFavoriteClick.bind(this);
  }

  specialIcons(item) {
    if (!item.is_new_year_offer) return null;
    return (
      <div className='card__thumb-icon'>
        <div className='icon icon-ny icon-ny-dims' />
      </div>
    );
  }

  handleFavoriteClick() {
    const { item, toggleFavoriteCamp } = this.props;
    toggleFavoriteCamp(item, $(this));
  }

  handleCardClick(e) {
    if (!e.target.closest('.card_map__favorite-block')) {
      window.open(this.props.item.seo_path, '_blank');
    }
  }

  render() {
    const { item, totalGuestsCount } = this.props;
    const { priceMin, priceMinWithoutDiscount, bonuses, tariff, allGuestCount, discount } = getTariffData(item);
    let priceString, priceWithoutDiscountString, guestsString, bonusesString;
    const apartments = item.apartments;
    const complexPlacement = item.complex_placement;
    const search_data = JSON.parse($.cookie('search_data'));
    const validSearch = search_data.date_start !== null && date_end !== null;

    if (!item.price_loaded) {
      priceString = <div className='priceLoading'>Данные загружаются...</div>;
      priceWithoutDiscountString = null;
    } else if (priceMin != null && priceMin !== -1) {
      priceString = `${Math.floor(priceMin).toLocaleString('ru-RU')} ${item.currency_name}`;
      priceWithoutDiscountString = `${Math.floor(priceMinWithoutDiscount).toLocaleString('ru-RU')} ${item.currency_name}`;
      const seats = allGuestCount || totalGuestsCount;
      guestsString = seats ? i18next.t('for_guest', { count: seats }) : undefined;
    } else if (!validSearch) {
      priceString = null;
      priceWithoutDiscountString = null;
    } else {
      priceString = 'Мест нет';
      priceWithoutDiscountString = null;
    }

    bonusesString = bonuses > 0 ? i18next.t('bonus', { count: bonuses }) : undefined;

    return (
      <div
        className='card card_map cards-map-card cards-map-card_1'
        data-link={item.seo_path}
        onClick={(e) => {
          this.handleCardClick(e);
        }}
      >
        <div className='card__thumb'>
          {this.specialIcons(item)}

          <div className='card__thumb-slider'>
            <div className='card__thumb-slider-item'>
              <img className='card__thumb-img' src={item.main_big_photo} />
            </div>
          </div>
        </div>

        <div className='card__desc'>
          <a className='card__desc-top'>
            <div className='card__title'>{item.full_name}</div>

            <div
              className='card_map__favorite-block'
              data-camp-id={item.id}
              data-favorited={this.props.isFavorite}
              onClick={(e) => {
                e.stopPropagation();
                this.handleFavoriteClick();
              }}
            >
              <div className={`favorite ${this.props.isFavorite ? 'unfavorite-icon' : 'favorite-icon'}`}></div>
            </div>
          </a>

          {(item.rating > 0 || item.is_recommended) && (
            <CampCardTags
              rating={item.rating}
              is_recommended={item.is_recommended}
              ratings_count_string={item.ratings_count_string}
            />
          )}

          {(apartments || complexPlacement) && (
            <div className='card__labels'>
              <CampCardServices
                tariff={tariff}
                foodTypeName={tariff?.food_name}
                isFreeCancellation={item.is_free_cancellation}
                instantBooking={item.is_can_instant_booking}
                isSeparator={false}
              />
            </div>
          )}

          <div className='card__price'>
            {discount > 0 && priceWithoutDiscountString && (
              <div className='discount-box'>
                <div className='price_discount-value'>{priceWithoutDiscountString}</div>
                <div className='price_discount-percent'>-{discount}%</div>
              </div>
            )}
            {priceString && (
              <a className='price-box' target='_blank'>
                <span className='text_black price rub-icon_black rub-map'>{priceString}</span>
                {guestsString && <span className='card_map__guests'>{guestsString}</span>}
              </a>
            )}
            <a className='price-box' target='_blank'>
              {bonusesString && <span className='bonuses bonuses-gradient'>{bonusesString}</span>}
            </a>
          </div>
          {complexPlacement && <div className={'card_map__guests'}>{complexPlacement.apartments_categories_count}</div>}
        </div>
      </div>
    );
  }
}
